import React from "react";
import { Phone } from "lucide-react";
import { CONTACT } from "@/data/site";

// Bouton d'appel flottant (desktop) — incite le visiteur à passer à l'action.
export default function FloatingCall() {
  return (
    <a
      href={`tel:${CONTACT.phoneTel}`}
      data-testid="floating-call-btn"
      className="hidden lg:flex fixed bottom-7 right-7 z-50 items-center gap-3 rounded-full bg-flame pl-4 pr-6 py-3.5 text-white font-bold shadow-[0_16px_40px_-10px_rgba(255,106,0,0.7)] transition-transform duration-300 hover:scale-105 group"
      aria-label={`Appelez-nous au ${CONTACT.phoneDisplay}`}
    >
      <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-white/20">
        <span className="absolute inset-0 rounded-full bg-white/30 animate-ping" />
        <Phone size={20} className="relative" />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-white/80">Appelez-nous</span>
        <span className="text-base font-extrabold">{CONTACT.phoneDisplay}</span>
      </span>
    </a>
  );
}
